import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class BrandName extends Component {
  static propTypes = {
    isChecked: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = { value: '' };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    if (this.props.isChecked) {
      return (
        <input
          className="c-rtool__input-text"
          type="text"
          value={this.state.value}
          onChange={this.handleChange}
          autoFocus
        />
      );
    }

    return (
      <span>Other</span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InputToggle.js